import { IconSVG } from '../types';

export const Close = ({ size, style }: IconSVG) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12 13.852l-4.674 4.674c-.25.25-.558.374-.926.374s-.677-.125-.926-.374A1.258 1.258 0 015.1 17.6c0-.368.125-.677.374-.926L10.148 12 5.474 7.326A1.258 1.258 0 015.1 6.4c0-.368.125-.677.374-.926.25-.25.558-.374.926-.374s.677.125.926.374L12 10.148l4.674-4.674c.25-.25.558-.374.926-.374s.677.125.926.374c.25.25.374.558.374.926s-.124.677-.374.926L13.852 12l4.674 4.674c.25.25.374.558.374.926s-.124.677-.374.926c-.25.25-.558.374-.926.374s-.677-.125-.926-.374L12 13.852z" />
  </svg>
);
